(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["breadcrumb-pdp"] && !Shopify.designMode) return;
  try {
    (()=>{const e="history-li";function t(e,t){const n=document.createElement("li"),o=document.createElement("a"),r=t.cloneNode(!0);o.href=e.url;const c=function(e){if(e)return e.replace("&amp;","&")}(e.title);return o.innerText=c,n.appendChild(o),n.appendChild(r),n}document.addEventListener("historyReady",(function(){!function(){const n=function(){const e=sessionStorage.getItem("tempBrowsingHistory")||null;if(e)return JSON.parse(e)}();if(!n)return;if(1===n.length&&window.location.href.includes(n[0].url))return;const o=document.querySelector("#collection-li"),r=o.querySelector("svg").cloneNode(!0);let c=0;n.slice().reverse().forEach(((n,i)=>{if(n&&n.url&&n.title&&n.title.length>1&&!window.location.href.includes(n.url)){switch(c){case 0:const c=t(n,r);c.id=e,o.replaceWith(c);break;case 1:const i=document.getElementById(e),l=t(n,r);i?i.parentNode.insertBefore(l,i):o.parentNode.after(l,o)}c++}}))}()}))})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cc-arrow-btn"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.cc-arrow-btn[data-scroll-target]').forEach(function(btn) {
    var target = document.querySelector(btn.dataset.scrollTarget);
    if (!target) return;
    var scrollAmount = target.offsetWidth * 0.8;

    btn.addEventListener('click', function() {
      var direction = btn.classList.contains('cc-arrow-btn--prev') ? -1 : 1;
      target.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cc-heading"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.cc-heading__arrows').forEach(function(el) {
    var target = document.querySelector(el.dataset.scrollTarget);
    if (!target) return;
    var prev = el.querySelector('.cc-heading__arrow--prev');
    var next = el.querySelector('.cc-heading__arrow--next');
    var scrollAmount = target.offsetWidth * 0.8;

    prev.addEventListener('click', function() {
      target.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
    next.addEventListener('click', function() {
      target.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cc-product-card"] && !Shopify.designMode) return;
  try {
    // Swap the card image to a variant's image while a colour swatch is hovered/focused.
  // Delegated on document so it also covers cards injected by the collection grid's AJAX.
  (function () {
    var SWATCH = '.cc-product-card__swatch[data-variant-image]';

    function cardImage(swatch) {
      var card = swatch.closest('.cc-product-card');
      return card ? card.querySelector('.cc-product-card__image') : null;
    }

    function show(swatch) {
      var img = cardImage(swatch);
      var url = swatch.getAttribute('data-variant-image');
      if (!img || !url) return;
      if (img.dataset.ccOrigSrc === undefined) {
        img.dataset.ccOrigSrc = img.getAttribute('src') || '';
        img.dataset.ccOrigSrcset = img.getAttribute('srcset') || '';
      }
      img.setAttribute('src', url);
      img.setAttribute('srcset', '');
    }

    function restore(swatch) {
      var img = cardImage(swatch);
      if (!img || img.dataset.ccOrigSrc === undefined) return;
      img.setAttribute('src', img.dataset.ccOrigSrc);
      if (img.dataset.ccOrigSrcset) {
        img.setAttribute('srcset', img.dataset.ccOrigSrcset);
      } else {
        img.removeAttribute('srcset');
      }
    }

    function onEnter(e) {
      var swatch = e.target.closest && e.target.closest(SWATCH);
      if (swatch) show(swatch);
    }

    function onLeave(e) {
      var swatch = e.target.closest && e.target.closest(SWATCH);
      if (swatch) restore(swatch);
    }

    document.addEventListener('mouseover', onEnter);
    document.addEventListener('mouseout', onLeave);
    document.addEventListener('focusin', onEnter);
    document.addEventListener('focusout', onLeave);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ctv-navigation"] && !Shopify.designMode) return;
  try {
    (()=>{"use strict";const e={visible:"is-visible",active:"is-active"},t={};function n(){t.headerHeight=t.header.getBoundingClientRect(),t.headerTop=t.headerHeight.height}function i(){t.navToggleElement.removeEventListener("click",o)}function a(){window.matchMedia(`(max-width: ${window.theme.breakpoints.lg}px)`).matches&&t.navToggleElement&&t.navToggleElement.addEventListener("click",o)}function o(){t.navContainerElement.classList.toggle(e.visible),t.navToggleElement.classList.toggle(e.active)}function d(){window.matchMedia(`(min-height: ${window.theme.breakpoints.md}px)`).matches?t.navElement.style.top=`${t.headerTop}px`:t.navElement.style.top="auto"}window.onload=function(){t.navElement=document.querySelector("[data-ctv-nav-container]"),t.navContainerElement=document.querySelector("[data-ctv-nav]"),t.navToggleElement=document.querySelector("[data-ctv-nav-open]"),t.header=document.querySelector(".site-header"),n(),a(),d(),window.addEventListener("breakpoint-down:lg",a),window.addEventListener("breakpoint-up:lg",i),window.addEventListener("resize",(e=>{window.innerHeight<"768"?(n(),t.navElement.style.top="auto"):(n(),d())}))}})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["featured-promotions-blocks"] && !Shopify.designMode) return;
  try {
    (()=>{"use strict";var e,i;e="section-featured-promotions",i={async onLoad(){this.loadSlider()},loadSlider(){window.theme.Swiper?this.initSlider():document.addEventListener("theme:inititialised",(()=>{this.initSlider()}),{once:!0})},initSlider(){this.container.querySelectorAll("[data-sfp-slider]").forEach((e=>{const i=e.querySelector("[data-sfp-slider-scrollbar]");new window.theme.Swiper(e,{slidesPerView:1.1,loop:!1,spaceBetween:16,slideToClickedSlide:!0,freeMode:{enabled:!0,sticky:!1,momentumBounce:!1},scrollbar:{el:i,draggable:!0},mousewheel:!0,breakpoints:{[theme.breakpoints.sm]:{slidesPerView:"auto"}}})}))}},Shopify.theme.sections&&Shopify.theme.sections.register?(0===Shopify.theme.sections.getInstances(e).length&&Shopify.theme.sections.register(e,i),Shopify.theme.sections.load(e)):function(e,i){var t={name:e,events:i};theme.sections.push(t)}(e,i)})();
  } catch(e) { console.error(e); }
})();

})();
